// For historical reasons the key scheme is: [COMPANY].[USER_ID].[STORAGE_IDENTIFIER]
export const getFullKey = (originalKey: string) => `small-improvements.*.${originalKey}`;

export const replaceObjectInStorage = <T>(key: string, object: T): void => {
    window.localStorage.setItem(getFullKey(key), JSON.stringify(object));
};

export function getObjectFromStorage<T>(key: string, fallback: T): T;
export function getObjectFromStorage<T extends object>(key: string): T | {};
export function getObjectFromStorage(key: string, fallback = {}): any {
    const item = window.localStorage.getItem(getFullKey(key)) || '';
    try {
        return JSON.parse(item);
    } catch {
        return fallback;
    }
}

export const updateObjectInStorage = <T extends object>(key: string, object: T): void => {
    replaceObjectInStorage(key, { ...getObjectFromStorage(key), ...(object as any) });
};

export const removeObjectInStorage = (key: string) => {
    window.localStorage.removeItem(getFullKey(key));
};
